import {type Router} from '@angular/router';
import {buildPlatformAwareRoutePathname, type AppLanguageCode} from '../shared/i18n/app-language';

type ContainerPathSegment = {
  id: string;
  name: string;
};

type ItemActionNavigationContext = {
  containerId: string;
  currentPath: ContainerPathSegment[];
  containerName?: string;
  languageCode: AppLanguageCode;
  sourceOrigin?: 'item-details';
  returnUrl: string;
};

type ItemActionNavigationTarget = {
  description: string | null;
  id: string;
  imageUrl: string | null;
  name: string;
  quantity: number;
};

export function navigateItemAction(
  router: Router,
  actionId: string,
  context: ItemActionNavigationContext,
  item: ItemActionNavigationTarget,
): void {
  if (actionId === 'add-to-basket') {
    const target = buildPlatformAwareRoutePathname('/basket/new', context.languageCode);
    void router.navigateByUrl(target, {
      state: {
        basketPrefill: {itemId: item.id, containerId: context.containerId},
        returnUrl: context.returnUrl,
      },
    });
    return;
  }

  if (actionId === 'clone' || actionId === 'edit') {
    const target = buildPlatformAwareRoutePathname(
      `/inventory/containers/${context.containerId}/items/${item.id}/${actionId}`,
      context.languageCode,
    );

    void router.navigateByUrl(target, {
      state: {
        containerPath: context.currentPath,
        returnUrl: context.returnUrl,
      },
    });
    return;
  }

  if (actionId === 'write-off') {
    const target = buildPlatformAwareRoutePathname('/write-off', context.languageCode);
    const searchParams = new URLSearchParams({
      sourceKind: 'item',
      containerId: context.containerId,
      itemId: item.id,
    });

    void router.navigateByUrl(`${target}?${searchParams.toString()}`, {
      state: {
        containerPath: context.currentPath,
        returnUrl: context.returnUrl,
      },
    });
    return;
  }

  if (actionId === 'move') {
    const target = buildPlatformAwareRoutePathname('/relocation', context.languageCode);
    void router.navigateByUrl(target, {
      state: {
        source: {
          kind: 'item',
          item: {
            id: item.id,
            name: item.name,
            description: item.description,
            imageUrl: item.imageUrl,
            quantity: item.quantity,
            containerId: context.containerId,
            containerName: context.containerName ?? context.currentPath[context.currentPath.length - 1]?.name ?? '',
            containerPath: context.currentPath,
          },
        },
        sourceOrigin: context.sourceOrigin,
        returnUrl: context.returnUrl,
      },
    });
  }
}
